import { Component, Input, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { ApiService } from '@services/api/api.service';
import { EventsService } from '@services/events/events.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { API_ENDTPOINTS } from '@models/api-endpoints';
import { IPaymentConfig } from '@models/payment.model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-otd-sip-toggle',
  standalone: true,
  imports: [
    NgIf,
    MatSlideToggleModule
  ],
  templateUrl: './otd-sip-toggle.component.html',
  styleUrls: ['./otd-sip-toggle.component.scss']
})
export class OtdSipToggleComponent {

  readonly vars = inject(VariablesService);
  private events = inject(EventsService);
  private paymentUtil = inject(PaymentUtilService);
  readonly util = inject(UtilService);
  private api = inject(ApiService);

  @Input() payment_config: IPaymentConfig;
  isContributeCalled = false;
  pre_currency = 'INR';

  subs: Subscription[] = [];

  ngOnInit() {
    this.setConfig();
  }

  setConfig() {
    this.subs.push(this.paymentUtil.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
        if (c?.currency) {
          this.getSipContribute();
        }
      }
    }));
  }

  async sipToggle(checked) {
    if (!this.isContributeCalled) {
      await this.getSipContribute();
    }
    this.paymentUtil.paymentConfig.next({ is_sip: checked });
    const payload = {
      eventName: 'toggleswitch',
      info_1: checked ? 'sip' : 'one time'
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

  async getSipContribute() {
    return new Promise((resolve, reject) => {
      try {
        this.isContributeCalled = true;
        let qParam = `?currency=${this.payment_config.currency}&origin=${this.payment_config.origin}&${this.vars.utmsUrlString}`;
        const url = API_ENDTPOINTS.GET_RECURRING_CONTRIBUTE_DETAILS + qParam;
        this.api.get(url).subscribe(res => {
          this.paymentUtil.paymentConfig.next({ sip_contribute_details: res?.data?.data });
          this.isContributeCalled = false;
          resolve(true);
        });
      } catch (error) {
        reject(false);
      }
    });

  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
